export default [
  {
    path: "/contractmanagment/contractdata",
    name: "contractdata",
    component: () =>
      import("@/views/pages/contractmanagment/contractdata/contractdata.vue"),
    props: true,

    meta: {
      pageTitle: "合約資料維護",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/daycheckout",
    name: "daycheckout",
    component: () =>
      import("@/views/pages/contractmanagment/daycheckout/daycheckout.vue"),
    props: true,

    meta: {
      pageTitle: "日結維護",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/accountcheckout",
    name: "accountcheckout",
    component: () =>
      import(
        "@/views/pages/contractmanagment/accountcheckout/accountcheckout.vue"
      ),
    props: true,

    meta: {
      pageTitle: "專戶結清作業",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/checkoutwork",
    name: "checkoutwork",
    component: () =>
      import("@/views/pages/contractmanagment/checkoutwork/checkoutwork.vue"),
    props: true,

    meta: {
      pageTitle: "結案作業",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/accountbalance",
    name: "accountbalance",
    component: () =>
      import(
        "@/views/pages/contractmanagment/accountbalance/accountbalance.vue"
      ),
    props: true,

    meta: {
      pageTitle: "日結專戶餘額維護",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/contractdaycheckout",
    name: "contractdaycheckout",
    component: () =>
      import(
        "@/views/pages/contractmanagment/contractdaycheckout/contractdaycheckout.vue"
      ),
    props: true,

    meta: {
      pageTitle: "合約件數日結",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/contractmanagment/contractmonthcheckout",
    name: "contractmonthcheckout",
    component: () =>
      import(
        "@/views/pages/contractmanagment/contractmonthcheckout/contractmonthcheckout.vue"
      ),
    props: true,

    meta: {
      pageTitle: "合約件數月結",
      breadcrumb: [
        {
          text: "合約管理作業",
          active: true,
        },
      ],
    },
  },
   {
    path: "/ContractmMobileUpload",
    name: "ContractmMobileUpload",
    component: () =>
      import(
        "@/components/Guarantee2/ContractmMobileUpload.vue"
      ),
    props: true,
    meta: {
      layout: "full",
    },
  },
];
